import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { LicenseState } from '@/app/license/store/state'

export const getters: GetterTree<LicenseState, RootState> = {}
